<template>
    <section class="home-sec3">
        <div class="home-sec3-video">
            <div class="iframe-filo"><iframe src="https://ifilo.net/embed/2IWYxJD" allowFullScreen="true" webkitAllowFullscreen="true" mozAllowFullscreen="true"  scrolling="no"></iframe></div>
        </div>
        <p class="home-sec3-txt">با ثبت تبلیغات در آن کلیک رویای شیرین داشتن میلیون ها مشتری، به واقعیت می پیوندد.</p>
    </section>
</template>

<script>
export default {
    name: "HomeSection3",

    setup() {

        return {}
    },
};
</script>

<style scope>
.home-sec3 {
    margin-inline: 33.334%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
}

.home-sec3-video {
    aspect-ratio: 640 / 360;
    width: 100%;
    max-height: 360px;
}

.home-sec3-video iframe {
    aspect-ratio: 16/9;
    width: 100%;
    height: 100%;
    border-radius: 20px;
    object-fit: contain;
    box-shadow: 0 0 10px var(--shadow-light);
    border: none;
}

.home-sec3-txt {
    padding-inline: 12.814%;
    font-size: 20px;
    text-align: justify;
}

@media screen and (min-width: 1921px) {
    .home-sec3 {
        width: 640px;
        margin-inline: auto;
    }
}

@media screen and (max-width: 1440px) {
    .home-sec3 {
       margin-inline: 28.334%;
    }
}

@media screen and (max-width: 1024px) {
    .home-sec3 {
       margin-inline: 23.334%;
    }
}

@media screen and (max-width: 768px) {
    .home-sec3 {
        margin-inline: 15.334%;
    }

     .home-sec3-txt {
        padding-inline: 0;
        font-size: 16px;
    }
}

@media screen and (max-width: 576px) {
    .home-sec3 {
        margin-inline: 5.556%;
    }
}

@media screen and (max-width: 360px) {
    .home-sec3-video {
        max-height: 167px;
    }
}
</style>